/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import logger from '../utils/logger';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { checkFavProcess } from '../api/api';

const useCheckFavorite = ({ id, nodes = [], childNodes = [], setIsFavorite }) => {
  const LoginUser = useSelector((state) => state.user.user);

  // ✅ PageGroupId ko effect ke bahar nikal lo
  const PageGroupId = nodes.length > 0 ? nodes[0]?.page_group_id : childNodes[0]?.page_group_id;

  useEffect(() => {
    const checkFav = async () => {
      // const user_id = LoginUser?.id || null;
      const process_id = id || null;

      if (!process_id) {
        logger.error('Missing required fields:', { process_id });
        return;
      }

      try {
        const response = await checkFavProcess(process_id, PageGroupId);

        setIsFavorite(response.exists);
      } catch (error) {
        logger.error('❌ checkFav error:', error);
      }
    };

    checkFav();
  }, [LoginUser, id, PageGroupId]); // ✅ ab error nahi aayega
};

export default useCheckFavorite;
